/*
* capitalize : given a string, capitalizes the first letter
* of each word
*/
const CASES = [
  'U.S.', 'US', 'LLC', 'LLP'
]
export default function capitalize(s: string) {
  //if this is a string
  if(typeof s === "string") {
    const ss = s.split(' '); //split the string by spaces

    return ss.map((x) => {
      //if this string is one of the exceptions
      if (CASES.includes(x.toUpperCase())) {
        return x.toUpperCase();
      }
      //else if there is one character or less
      else if (x.length <= 1) {
        return x.toUpperCase();
      }
      //else capitalize the first character, then lowercase the rest
      else {
        return x[0].toUpperCase() + x.substr(1).toLowerCase();
      }
    }).join(' '); //join the string by spaces
  }
}
